import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API_BASE_URL } from "../../../constants";
import { fetchMyCoachStatus } from "../../auth/Onboarding/services/onboardingServices";
import { BmModal, Btn, Overline } from "../../ForBrands/ui/BrandUI";
import { codeCoverageLine, teamCodeFor } from "./teamCodes";

// "Team Code" / "Invite someone": the code of the team the page has open
// (`team`, else the coach's primary team). Each team has one code its
// coaches share; athletes enter it in their CACHE profile to link to that
// roster (the verification panel shows the primary team's). A program code
// covers every age group of the program, and the line under it says so
// with the age groups (teamCodes.codeCoverageLine). Staff viewing a coach
// read that coach's codes instead.
const AddPlayerCodeModal = ({ open, onClose, coachEmail = "", team = null, title = "Add players to your team" }) => {
  const [record, setRecord] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!open) return;
    setCopied(false);
    if (coachEmail) {
      axios
        .get(`${API_BASE_URL}/users/by-email/`, { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }, params: { email: coachEmail } })
        .then((res) => setRecord(res.data?.coachVerification || {}))
        .catch(() => {});
    } else {
      fetchMyCoachStatus()
        .then((st) => setRecord(st || {}))
        .catch(() => {});
    }
  }, [open, coachEmail]);

  if (!open) return null;

  const coverage = teamCodeFor(record, team);
  const { code } = coverage;
  const covers = code ? codeCoverageLine(coverage, "For") : "";
  const status = record?.status || "";

  const copy = () => {
    navigator.clipboard?.writeText(code).then(
      () => {
        setCopied(true);
        toast.success("Team code copied.");
      },
      () => toast.error("Could not copy the code."),
    );
  };

  return (
    <BmModal
      title={title}
      onClose={onClose}
      footer={
        <>
          <Btn variant="secondary" className="flex-1" onClick={onClose}>
            Close
          </Btn>
          <Btn className="flex-1" disabled={!code} onClick={copy}>
            {copied ? "Copied" : "Copy code"}
          </Btn>
        </>
      }
    >
      <p className="bm-body-m text-bm-muted">
        Share your team code. Athletes enter it under Edit my profile in CACHE to link to your roster; guardians and agents get access
        through the athlete's Circle.
      </p>
      <div className="mt-4 flex flex-col items-center gap-1 rounded-[8px] border border-bm-border bg-bm-subtle py-5">
        <Overline>Team code</Overline>
        <span className="font-archivo text-[36px] font-bold tracking-[6px] text-bm-orange">{code || "······"}</span>
        {covers && <span className="bm-body-s text-bm-muted">{covers}</span>}
        {status && status !== "verified" && (
          <span className="bm-body-s text-bm-muted">Your code unlocks once an admin verifies your coach account.</span>
        )}
      </div>
    </BmModal>
  );
};

export default AddPlayerCodeModal;
